export const ASSESSMENT = {
  not_started: { label: 'Not started', cls: 'bg-slate-100 text-slate-600' },
  in_progress: { label: 'In progress', cls: 'bg-amber-100 text-amber-800' },
  completed: { label: 'Completed', cls: 'bg-teal-100 text-teal-800' },
};

export const STATUS_CLS = {
  'Not Contacted': 'bg-slate-100 text-slate-600',
  Contacted: 'bg-blue-100 text-blue-800',
  Interested: 'bg-violet-100 text-violet-800',
  'Not Interested': 'bg-slate-200 text-slate-700',
};

export const CONSULT = { booked: ['Booked', 'bg-violet-100 text-violet-800'], checkout_started: ['Checkout started', 'bg-amber-100 text-amber-800'] };

export const ACTIVATION = {
  activated: ['Activated', 'bg-teal-50 text-teal-700'], invited: ['Invited', 'bg-sky-50 text-sky-700'], invite_expired: ['Invite expired', 'bg-amber-50 text-amber-700'],
  requested: ['Requested activation', 'bg-rose-50 text-rose-700'], not_invited: ['Not invited', 'bg-slate-100 text-slate-600'],
};

export const QUEUE_KEY = 'elevate_wa_outreach_queue';

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) : '—');

export const ago = (iso) => {
  if (!iso) return 'Never';
  const d = Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
  return d <= 0 ? 'Today' : d === 1 ? 'Yesterday' : `${d} days ago`;
};

export const waUrl = (phone, text) => `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;

export const Pill = ({ cls, children, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold whitespace-nowrap ${cls}`}>{children}</span>
);
